import { postToWarehouse } from "./warehouseAPIClient";
import { RemoveEmptyFields } from "../helpers/helper";
// #region Stock

/**
 * Get the stock of a warehouse with a API call
 * @param {any} data
 * @returns
 */
export async function getStockAPI(jwtToken, data) {
    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("warehouseStockAPI", jwtToken, dataSend, "Get Stock API")
    } catch (error) {
        console.error(error);
    }
}

/**
 * Get the stock of a warehouse from DB
 * @param {any} data
 * @returns
 */
export async function getStock(jwtToken, data, filters) {
    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("warehouseStock", jwtToken, dataSend, "Get Stock DB")
    } catch (error) {
        console.log(error);
    }
}

// #endregion

// #region Orders

/**
 * Get a order
 * @param {any} data
 * @returns
 */
export async function GetOrders(jwtToken, data){

    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("getOrders", jwtToken, dataSend, "Get Orders API")
    } catch (error) {
        console.log(error);
    }

}

/**
 * Send orderd
 * @param {any} data
 * @returns
 */
export async function SendOrder(jwtToken, data) {

    try {
        //const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("createOrder", jwtToken, data, "Send Order API")
    } catch (error) {
        console.log(error);
    }

}

/**
 * Cancel orderd
 * @param {any} data
 * @returns
 */
export async function CancelOrder(jwtToken, data) {

    try {
        //const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("cancelOrder", jwtToken, data, "Cancel Order API")
    } catch (error) {
        console.log(error);
    }

}

// #endregion

//#region Products

/**
 * Get one product
 * @param {any} data
 * @returns
 */
export async function ReturnRegistryProduct(jwtToken, data) {

    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("returnProduct", jwtToken, dataSend);
    } catch (error) {
        console.log(error);
    }

}

/**
 * Registry a product
 * @param {any} data
 * @returns
 */
export async function RegistryProduct(jwtToken, data) {

    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("registryProduct", jwtToken, dataSend)
    } catch (error) {
        console.log(error);
    }
}

/**
 * 
 * @param {any} data
 * @returns
 */
export async function RegistryProducMultiSKU(jwtToken, data) {

    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("registryProductMultiSKU", jwtToken, dataSend)
    } catch (error) {
        console.log(error);
    }
}

//#endregion

//#region Dealers

export async function getDealers(jwtToken, data) {
    try {
        const dataSend = RemoveEmptyFields(data);
        return postToWarehouse("getDealers", jwtToken, dataSend, "get delaer info")
    } catch (error) {
        console.error(error);
    }
}
    
//#endregion